(() => {
  const root = document.querySelector('[data-mayhem-pdp-summary]');
  const specs = document.querySelector('[data-mayhem-specs]');
  const panel = root?.querySelector('[data-mayhem-configuration]');
  if (!panel || !specs || panel.dataset.ready) return;
  panel.dataset.ready = 'true';
  const L = JSON.parse(root.querySelector('[data-config-labels]').textContent);
  const price = root.querySelector('[data-config-price]');
  const select = panel.querySelector('[data-config-select]');
  const label = panel.querySelector('[data-config-label]');
  const help = panel.querySelector('[data-config-help]');
  const summary = panel.querySelector('[data-config-summary]');
  const rows = [...specs.querySelectorAll('[data-spec-row]')];
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });
  const cell = (row, name) => row.querySelector(`[data-label="${name}"]`)?.textContent.trim() || '';
  const description = row => [row.dataset.size, L.bolt + ': ' + cell(row, 'Bolt pattern'), L.offset + ': ' + cell(row, 'Offset')].filter(Boolean).join(' · ');
  const lugGroup = root.querySelector('[data-mayhem-lug-group]');
  const lugInfo = document.createElement('p');
  lugInfo.className = 'mayhem-config__lug-info';
  lugInfo.hidden = true;
  lugGroup?.append(lugInfo);
  const finishChooser = root.querySelector('.mayhem-finish-switcher');
  if (finishChooser && finishChooser.querySelectorAll('a').length === 1) finishChooser.hidden = true;
  const actionHelp = root.querySelector('[data-config-actions-help]');
  let optionKey = '';
  const update = () => {
    const ids = JSON.parse(specs.dataset.candidateIds || '[]');
    const candidates = rows.filter(row => ids.includes(row.dataset.variantId));
    const selected = candidates.find(row => row.dataset.variantId === specs.dataset.selectedVariantId);
    const pending = specs.dataset.fitmentPending === 'true';
    panel.hidden = false;
    const eligibleLugs = [...new Set(rows.filter(row => !specs.dataset.fitmentVehicleId || ['fits', 'caution'].includes(row.dataset.fitmentState)).map(row => row.dataset.lug))];
    const singleLug = !pending && eligibleLugs.length === 1;
    lugGroup?.classList.toggle('has-single-lug', singleLug);
    lugInfo.hidden = !singleLug;
    if (singleLug) lugInfo.textContent = L.lug + ': ' + (root.querySelector(`[data-mayhem-lug="${eligibleLugs[0]}"]`)?.textContent.trim() || eligibleLugs[0]);
    const differs = getter => new Set(candidates.map(getter)).size > 1;
    const showSize = differs(row => row.dataset.size);
    const showBolt = differs(row => cell(row, 'Bolt pattern'));
    const showOffset = differs(row => cell(row, 'Offset'));
    const choiceLabel = showSize
      ? (showBolt ? (showOffset ? L.choose_size_bolt_offset : L.choose_size_bolt) : (showOffset ? L.choose_size_offset : L.choose_size))
      : (showBolt ? (showOffset ? L.choose_bolt_offset : L.choose_bolt) : (showOffset ? L.choose_offset : L.choose));
    label.textContent = choiceLabel;
    const key = ids.join('|') + ':' + choiceLabel;
    if (optionKey !== key || !select.options.length) {
      select.replaceChildren(new Option(choiceLabel, ''));
      candidates.forEach(row => {
        const parts = [showSize ? row.dataset.size : '', showBolt ? L.bolt + ': ' + cell(row, 'Bolt pattern') : '', showOffset ? L.offset + ': ' + cell(row, 'Offset') : '', row.dataset.sku];
        select.add(new Option(parts.filter(Boolean).join(' · '), row.dataset.variantId));
      });
      optionKey = key;
    }
    select.value = selected?.dataset.variantId || '';
    select.hidden = candidates.length < 2 || pending;
    label.hidden = select.hidden;
    select.disabled = pending;
    help.hidden = Boolean(selected);
    if (actionHelp) actionHelp.hidden = Boolean(selected) || pending || !candidates.length;
    help.textContent = pending ? L.pending : !candidates.length ? L.none : L.optional;
    summary.replaceChildren();
    if (selected) {
      const heading = document.createElement('strong'); heading.textContent = L.your;
      const desc = document.createElement('p'); desc.textContent = description(selected);
      const sku = document.createElement('p'); sku.textContent = L.part + ': ' + selected.dataset.sku;
      const fitment = document.createElement('p');
      fitment.textContent = specs.dataset.fitmentVehicleId ? (selected.dataset.fitmentState === 'fits' ? L.fits : L.caution) : L.unverified;
      summary.append(heading, desc, sku);
      if (!specs.dataset.fitmentVehicleId) summary.append(fitment);
    }
    const pricedRows = selected ? [selected] : candidates;
    const amounts = pricedRows.map(row => Number(row.dataset.msrp)).filter(amount => Number.isFinite(amount) && amount > 0);
    price.hidden = pending || !candidates.length;
    price.replaceChildren();
    const amount = document.createElement('strong');
    const lo = Math.min(...amounts), hi = Math.max(...amounts);
    amount.textContent = amounts.length ? L.msrp + ': ' + money.format(lo) + (hi !== lo ? '–' + money.format(hi) : '') : L.price_missing;
    price.append(amount);
    if (amounts.length) { const unit = document.createElement('span'); unit.textContent = L.unit; price.append(unit); }
    if (amounts.length && amounts.length < pricedRows.length) { const note = document.createElement('small'); note.textContent = L.partial; price.append(note); }
    const selection = [root.querySelector('.mayhem-pdp-summary__title')?.textContent.trim().replace(/\s+/g, ' '),root.querySelector('.mayhem-pdp-summary__finish')?.textContent.trim(),specs.dataset.configurationSize,specs.dataset.configurationLug ? specs.dataset.configurationLug + ' Lug' : '',root.querySelector('[data-mayhem-fitment-selected-name]')?.textContent].filter(Boolean).join(' · ');
    try { sessionStorage.setItem('mayhem:configuration-preferences', JSON.stringify({ handle:root.dataset.productHandle, title:L.handoff, help:L.handoff_help, back:L.back, selection, url:location.pathname })); } catch {}
  };
  select.addEventListener('change', () => {
    if (select.value) document.dispatchEvent(new CustomEvent('mayhem:configuration-select', { detail: { variantId:select.value } }));
    else document.dispatchEvent(new CustomEvent('mayhem:configuration-clear'));
  });
  panel.querySelector('[data-config-spec-link]')?.addEventListener('click', event => {
    event.preventDefault();
    const target = rows.find(row => row.classList.contains('is-config-selected') && row.getClientRects().length) || specs;
    const focusTarget = (target !== specs && target.querySelector('[data-config-row-select]:not(:disabled)')) || specs.querySelector('h2') || specs;
    if (!focusTarget.matches('button,a,input,select,textarea,[tabindex]')) focusTarget.setAttribute('tabindex', '-1');
    focusTarget.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: target === specs ? 'start' : 'center' });
  });
  document.addEventListener('mayhem:spec-selection-changed', update);
  update();
})();

